import React from 'react';
import './Modal.css';
var ModalSkeleton = function (props) {
    var visible = props.visible, onClose = props.onClose;
    return visible ? (React.createElement("div", { className: "modal-mask" },
        React.createElement("div", { className: "modal-dialog show", style: { maxWidth: 550 } },
            React.createElement("div", { className: "modal-content" },
                React.createElement("div", { className: "modal-header align-items-center" },
                    React.createElement("span", { className: "skeleton-line skeleton-header skeleton-h-xl w-25" }),
                    React.createElement("button", { className: "btn btn-none", onClick: onClose },
                        React.createElement("i", { className: "fal fa-times fg-neutral-80" }))),
                React.createElement("div", { className: "modal-body", style: { minHeight: 230 } },
                    React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
                    React.createElement("span", { className: "skeleton-line skeleton-h-md" }),
                    React.createElement("span", { className: "skeleton-line skeleton-h-md w-75" })),
                React.createElement("div", { className: "modal-footer" },
                    React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-w-lg btn" }),
                    React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-header skeleton-w-lg btn mt-0" })))))) : null;
};
export default React.memo(ModalSkeleton);
